<template>
	<div id="details_application" style="padding-bottom: 20px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit">
			<van-field v-model="type_text" name="费用类型" label="费用类型" placeholder="选择费用类型" readonly
				@click="popup.type = true" :rules="[{ required: true, trigger: 'onBlur', message: '请选择费用类型' }]" />
			<van-field v-model="form.je" name="费用金额" label="费用金额" placeholder="输入费用金额" type="number"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入费用金额' }]" />
			<van-field v-model="form.occur_date" name="发生日期" label="发生日期" placeholder="选择发生日期" readonly
				@click="popup.calendar = true" :rules="[{ required: true, trigger: 'onBlur', message: '请选择发生日期' }]" />
			<van-field v-model="form.cause" rows="3" autosize label="申请事由" type="textarea" placeholder="请输入申请事由"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写申请事由' }]" />
			<van-field v-model="form.remark" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写备注' }]" />
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="uploader" :max-count="6" accept="all" :after-read="onAfterRead" />
				</template>
			</van-field>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.type" position="bottom">
			<van-picker show-toolbar :columns="typeList" @cancel="picker.type = false" @confirm="confirmType" />
		</van-popup>
		<van-calendar v-model="popup.calendar" type="single" :min-date="minDate" :default-date="today"
			@confirm="confirmCalendar" />
		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import { getNowFormatDate } from "@/utils/tool";
import { Toast } from "vant";
import navbar from "@/components/navBar/index";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 


export default {
	name: "carryout_details",
	components: {
		navbar,
	},
	data() {
		return {
			title: "新增费用申请",
			type_text: "",
			uploader: [],
			form: {
				type: "",
				cause: "",
				je: "",
				occur_date: "",
				remark: "",
				client_id: this.$route.query.client_id,
				order_id: this.$route.query.order_id,
			},
			popup: {
				type: false,
				calendar: false,
				process: false,
				select: false
			},
			processList: [],
			typeList: [
				{ text: "差旅费报销", id: 9 },
				{ text: "差旅费预支", id: 0 },
				{ text: "办公费", id: 1 },
				{ text: "招待费", id: 2 },
				{ text: "市内交通费", id: 3 },
				{ text: "通讯费", id: 4 },
				{ text: "采购付款", id: 5 },
				{ text: "居间费", id: 7 },
				{ text: "劳务支出", id: 8 },
				{ text: "其他", id: 6 }
			],
			signTime: true,
			minDate: new Date(new Date().getFullYear() - 1, 0, 1),//最小可选日期为过去一年
			// maxDate: new Date(),//最大可选日期
			today: new Date(),
		};
	},
	mounted() {
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("process_id", this.$route.query.process_id);
			formData.append("order_id", this.$route.query.order_id);
			formData.append("requestType", "process_apply");
			formData.append("apply_data", JSON.stringify(this.form));
			formData.append("apply_rmb", this.form.je);
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						Toast.fail("提交成功!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		confirmType(value) {
			this.type_text = value.text;
			this.form.type = value.id;
			this.popup.type = false;
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.client_id_text = "";
			this.type_text = "";
		},
		confirmCalendar(value) {
			this.form.occur_date = getNowFormatDate(value);
			this.popup.calendar = false;
		},
	},
};
</script>

<style lang="scss">
#details_application {
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
}
</style>
